import React, { useState, useEffect } from 'react';
import { toastifyFn, displayPrice, calculatePrice } from 'common/utilities/utils';
import { DRIVER_TIPPING } from '../constants/DeliveryTippingConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import DonationButtonGroup from 'molecules/DonationButtonGroup/DonationButtonGroup';
import { CUSTOM_DRIVER_TIPPING_AMOUNT_REGEX, percentageSymbol } from 'common/constants/SharedConstants';
import { validateCheckoutDetails } from 'common/utilities/CheckoutUtils';

export const driverTippingCaluclation = (data, chargeType) => {
  switch (chargeType) {
    case DRIVER_TIPPING.COMPOSITE:
    case DRIVER_TIPPING.PERCENTAGE:
      return data?.calculatedValue;
    case DRIVER_TIPPING.ABSOLUTE:
      return data?.value;
    default:
      return;
  }
};

export const handleSelectedClick = (selectedObj, index, componentData) => {
  const {
    donationsButtonData,
    setDonationsButtonData,
    updateCheckoutDetails,
    cartTotal,
    donationChargeType,
    checkoutDetails,
  } = componentData;
  const selectedItem = donationsButtonData?.donationChargeOption?.find(
    tippingOption => tippingOption?.name === selectedObj?.name,
  );
  const driverTippingChargeSelected = donationsButtonData?.donationChargeOption?.map((obj, i) => {
    return {
      ...obj,
      isDefault: index === i ? true : false,
    };
  });
  const checkoutData = checkoutDetails?.userParams?.loggedIn
    ? {
        ...checkoutDetails,
        guestCheckOutFieldsValidated: true,
      }
    : checkoutDetails;
  setDonationsButtonData({
    ...donationsButtonData,
    donationChargeOption: driverTippingChargeSelected,
    showDonationsCustomFields: selectedItem?.name === DRIVER_TIPPING?.OTHERS ? true : false,
    customAmount: '',
    addDonationBtnHandler: true,
    buttonText: translateWithI18Next(TRANSLATE_MAPPING_KEY?.ADD_DRIVER_TIP),
    editButtonShow: false,
    showCurrencyField: false,
    inputFiledValidErrormsg: '',
  });
  if (selectedItem?.name === DRIVER_TIPPING?.NOT_NOW) {
    updateCheckoutDetails({
      driverdeliveryTip: 0,
      total: cartTotal,
      driverTipDisplayAmount: '',
      paymentEnabled: true,
      isCustomTipSelected: true,
      finalAmount: calculatePrice(cartTotal, checkoutDetails?.currencyConversionFactor),
      isAddTipeSelected: false,
    });
    validateCheckoutDetails(checkoutData, updateCheckoutDetails);
  } else if (selectedItem?.name === DRIVER_TIPPING?.OTHERS) {
    updateCheckoutDetails({
      driverdeliveryTip: 1,
      total: cartTotal,
      driverTipDisplayAmount: '',
      paymentEnabled: false,
      isClickAddPayment: false,
      tender: { name: '' },
      isCustomTipSelected: false,
      finalAmount: calculatePrice(
        cartTotal + driverTippingCaluclation(selectedObj, donationChargeType),
        checkoutDetails?.currencyConversionFactor,
      ),
      isAddTipeSelected: false,
    });
  } else {
    updateCheckoutDetails({
      driverdeliveryTip: driverTippingCaluclation(selectedObj, donationChargeType),
      total: cartTotal + driverTippingCaluclation(selectedObj, donationChargeType),
      driverTipDisplayAmount: driverTippingCaluclation(selectedObj, donationChargeType),
      paymentEnabled: true,
      isCustomTipSelected: true,
      finalAmount: calculatePrice(
        cartTotal + driverTippingCaluclation(selectedObj, donationChargeType),
        checkoutDetails?.currencyConversionFactor,
      ),
      isAddTipeSelected: false,
      tender: { name: '', payload: {} },
      isClickAddPayment: false,
    });
    validateCheckoutDetails(checkoutData, updateCheckoutDetails);
  }
};

export const onChangeOrOnBlurHandler = (event, componentData) => {
  const { donationsButtonData, setDonationsButtonData, cartSubTotal, currencyConversionFactor } = componentData;
  const value = event.target.value;
  const tipAmount = Number((value * currencyConversionFactor).toFixed(2));
  if (tipAmount > Number(cartSubTotal)) {
    setDonationsButtonData({
      ...donationsButtonData,
      customAmount: value,
      inputFiledValidErrormsg: translateWithI18Next(TRANSLATE_MAPPING_KEY?.TIPPING_EXCEEDED_MSG),
    });
  } else if (value !== '' && (isNaN(value) || Number(value) < 1)) {
    setDonationsButtonData({
      ...donationsButtonData,
      customAmount: value,
      inputFiledValidErrormsg: translateWithI18Next(TRANSLATE_MAPPING_KEY?.TIPPING_INVALID_MSG),
    });
  } else {
    setDonationsButtonData({
      ...donationsButtonData,
      customAmount: value,
      inputFiledValidErrormsg: '',
    });
  }
};

export const addTipAmountHandler = componentData => {
  const {
    donationsButtonData,
    setDonationsButtonData,
    updateCheckoutDetails,
    guestCheckOutFieldsValidated,
    userParams,
    cartTotal,
    currencyConversionFactor,
  } = componentData;
  setDonationsButtonData({
    ...donationsButtonData,
    addDonationBtnHandler: false,
    editButtonShow: true,
    buttonText: translateWithI18Next(TRANSLATE_MAPPING_KEY?.UPDATE_DRIVER_TIP),
  });
  updateCheckoutDetails({
    driverdeliveryTip: Number(donationsButtonData?.customAmount) * currencyConversionFactor,
    total: Number(cartTotal) + Number(donationsButtonData?.customAmount) * currencyConversionFactor,
    finalAmount: calculatePrice(
      Number(cartTotal) + Number(donationsButtonData?.customAmount) * currencyConversionFactor,
      currencyConversionFactor,
    ),
    driverTipDisplayAmount: Number(donationsButtonData?.customAmount) * currencyConversionFactor,
    paymentEnabled: userParams?.loggedIn || guestCheckOutFieldsValidated ? true : false,
    isCustomTipSelected: true,
    isAddTipeSelected: true,
  });
  toastifyFn(translateWithI18Next(TRANSLATE_MAPPING_KEY?.TIP_ADDED_TOAST_MESSAGE), '', 'favorites-added-toast');
};

export const clearAmountHandler = componentData => {
  const { donationsButtonData, setDonationsButtonData, updateCheckoutDetails, checkoutDetails } = componentData;
  setDonationsButtonData({
    ...donationsButtonData,
    customAmount: '',
    inputFiledValidErrormsg: translateWithI18Next(TRANSLATE_MAPPING_KEY?.TIPPING_INVALID_MSG),
    editButtonShow: false,
    buttonText: translateWithI18Next(
      checkoutDetails?.isAddTipeSelected
        ? TRANSLATE_MAPPING_KEY?.UPDATE_DRIVER_TIP
        : TRANSLATE_MAPPING_KEY?.ADD_DRIVER_TIP,
    ),
    showCurrencyField: false,
  });
  updateCheckoutDetails({
    paymentEnabled: false,
    isClickAddPayment: false,
    tender: { name: '' },
    isCustomTipSelected: false,
  });
};

export const editAmountHandler = componentData => {
  const { donationsButtonData, setDonationsButtonData, updateCheckoutDetails } = componentData;
  setDonationsButtonData({
    ...donationsButtonData,
    addDonationBtnHandler: true,
    editButtonShow: false,
    buttonText: translateWithI18Next(TRANSLATE_MAPPING_KEY?.UPDATE_DRIVER_TIP),
  });
  updateCheckoutDetails({
    paymentEnabled: false,
    isClickAddPayment: false,
    tender: { name: '' },
    isCustomTipSelected: false,
  });
};

export const tippingSectionCaluclatedVal = (data, chargeType) => {
  switch (data?.name) {
    case DRIVER_TIPPING?.NOT_NOW:
      return translateWithI18Next(TRANSLATE_MAPPING_KEY?.NOT_NOW);
    case DRIVER_TIPPING?.OTHERS:
      return translateWithI18Next(TRANSLATE_MAPPING_KEY?.OTHER);
    default:
      return (
        (chargeType === DRIVER_TIPPING?.PERCENTAGE || chargeType === DRIVER_TIPPING?.COMPOSITE) &&
        `${data?.value}${chargeType !== DRIVER_TIPPING?.VALUE ? percentageSymbol : ''}`
      );
  }
};

export const tippingSectionPercentVal = (data, chargeType, currencySymbol, currencyConversionFactor) => {
  switch (data?.name) {
    case DRIVER_TIPPING?.NOT_NOW:
    case DRIVER_TIPPING?.OTHERS:
      return;
    default:
      return `${displayPrice(chargeType === DRIVER_TIPPING?.ABSOLUTE ? data?.value : data?.calculatedValue, {
        currencySymbol,
        currencyConversionFactor,
      })}`;
  }
};

export const getTippingClassName = tipping => {
  switch (tipping?.name) {
    case DRIVER_TIPPING?.NOT_NOW:
    case DRIVER_TIPPING?.OTHERS:
      return 'donationtext';
    default:
      return '';
  }
};
export const handleFocus = componentData => {
  const { donationsButtonData, setDonationsButtonData } = componentData;
  setDonationsButtonData({ ...donationsButtonData, showCurrencyField: true });
};

export const handleBlur = (event, componentData) => {
  const { donationsButtonData, setDonationsButtonData } = componentData;
  setDonationsButtonData({
    ...donationsButtonData,
    showCurrencyField: false,
    inputFiledValidErrormsg: translateWithI18Next(TRANSLATE_MAPPING_KEY?.TIPPING_INVALID_MSG),
  });
};
const CheckoutDeliveryTippingViews = props => {
  const { checkoutDetails, updateCheckoutDetails } = props;
  const {
    currencySymbol,
    currencyConversionFactor,
    driverTippingChargeType,
    driverTippingChargeOption,
    cartTotal,
    guestCheckOutFieldsValidated,
    userParams,
    cartSubTotal,
    driverTipDefaultSelected,
  } = checkoutDetails;
  const [donationsButtonData, setDonationsButtonData] = useState({
    donationChargeOption: driverTippingChargeOption
      ?.map(tipping => {
        return {
          ...tipping,
          displayChargeAmount: tippingSectionCaluclatedVal(tipping, driverTippingChargeType),
          containerClassName:
            driverTippingChargeType !== DRIVER_TIPPING.COMPOSITE ? 'donationtext' : getTippingClassName(tipping),
          displayNonPercentageAmount:
            driverTippingChargeType !== DRIVER_TIPPING?.PERCENTAGE
              ? tippingSectionPercentVal(tipping, driverTippingChargeType, currencySymbol, currencyConversionFactor)
              : '',
        };
      })
      .filter(tipping => {
        return tipping.isSelected;
      }),
    inputFiledValidErrormsg: '',
    customAmount: '',
    addDonationBtnHandler: true,
    showDonationsCustomFields: false,
    showNonDonationPercentage: driverTippingChargeType !== DRIVER_TIPPING?.PERCENTAGE ? true : false,
    donationRegexPattern: CUSTOM_DRIVER_TIPPING_AMOUNT_REGEX,
    editButtonShow: false,
    buttonText: translateWithI18Next(TRANSLATE_MAPPING_KEY?.ADD_DRIVER_TIP),
    showCurrencyField: false,
    paymentAllowed: userParams?.loggedIn ? true : guestCheckOutFieldsValidated,
  });

  useEffect(() => {
    if (!userParams?.loggedIn) {
      setDonationsButtonData({ ...donationsButtonData, paymentAllowed: guestCheckOutFieldsValidated });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guestCheckOutFieldsValidated]);

  useEffect(() => {
    const tippingDefaultValue = driverTipDefaultSelected?.[0];
    if (tippingDefaultValue?.name !== DRIVER_TIPPING?.NOT_NOW && tippingDefaultValue?.name !== DRIVER_TIPPING?.OTHERS) {
      updateCheckoutDetails({
        driverdeliveryTip: driverTippingCaluclation(tippingDefaultValue, driverTippingChargeType),
        total: cartTotal + driverTippingCaluclation(tippingDefaultValue, driverTippingChargeType),
        finalAmount: calculatePrice(
          cartTotal + driverTippingCaluclation(tippingDefaultValue, driverTippingChargeType),
          checkoutDetails?.currencyConversionFactor,
        ),
        driverTipDisplayAmount: driverTippingCaluclation(tippingDefaultValue, driverTippingChargeType),
      });
      setDonationsButtonData({ ...donationsButtonData, showDonationsCustomFields: false });
    } else if (tippingDefaultValue?.name !== DRIVER_TIPPING?.NOT_NOW) {
      updateCheckoutDetails({
        isCustomTipSelected: false,
      });
      setDonationsButtonData({ ...donationsButtonData, showDonationsCustomFields: true });
    } else {
      updateCheckoutDetails({
        driverdeliveryTip: 0,
      });
      setDonationsButtonData({ ...donationsButtonData, showDonationsCustomFields: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DonationButtonGroup
      donationsButtonData={donationsButtonData}
      setDonationsButtonData={setDonationsButtonData}
      cartTotal={cartTotal}
      currencySymbol={currencySymbol}
      currencyConversionFactor={currencyConversionFactor}
      updateCheckoutDetails={updateCheckoutDetails}
      donationChargeType={driverTippingChargeType}
      onClickDonationHandler={handleSelectedClick}
      onClickDonationAddHandler={addTipAmountHandler}
      onChangeInputHandler={onChangeOrOnBlurHandler}
      onClearDonationTextHandler={clearAmountHandler}
      onEditDonationTextHandler={editAmountHandler}
      title={translateWithI18Next(TRANSLATE_MAPPING_KEY?.TIP_YOUR_DRIVER_DESC)}
      shortDesc={translateWithI18Next(TRANSLATE_MAPPING_KEY?.TIP_YOUR_DRIVER)}
      manualEditButtonTitle={translateWithI18Next(TRANSLATE_MAPPING_KEY?.EDIT)}
      guestCheckOutFieldsValidated={guestCheckOutFieldsValidated}
      cartSubTotal={cartSubTotal}
      userParams={userParams}
      handleFocus={handleFocus}
      handleBlur={handleBlur}
      checkoutDetails={checkoutDetails}
    />
  );
};

export default CheckoutDeliveryTippingViews;
